export default __webpack_public_path__ + "static/media/emitir_certificados.506fcfbd.svg";